import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';
import { apiUrl } from '../utilities/type';
import { AxiosInstanceV2 } from '..';
import ReactS3Client from 'react-aws-s3-typescript';
import { s3Config } from './s3Config';

function sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
}

const convertFileToBase64 = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;

        reader.readAsDataURL(file.rawFile);
    });


const authClient = () => {
    const auth = JSON.parse(localStorage.getItem('auth') || "{}");
    AxiosInstanceV2.defaults.headers['x-access-token'] = auth.data.accessToken;
    return AxiosInstanceV2;
}

export const httpClient = (url, options = {headers: new Headers({ Accept: 'application/json' })}) => {
    // sleep(500);
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const { accessToken } = JSON.parse(localStorage.getItem('auth') || "{}");
    options.headers.set('x-access-token', accessToken);
    // const locale = localStorage.getItem('locale') || "en";
    // options.headers.set('locale', locale);
    return fetchUtils.fetchJson(url, options);
};

const pluralToSingle = {
    categories: 'category',
    recipes: 'recipe',
    videos: 'video',
    news: 'news',
    cms: 'cms',
    banners: 'banner' 
}

export default {
    getList: async (resource) => {
        // if(resource === 'infuencer'){
        //     const response = await AxiosInstanceV2.get('/videos?type=2');
        //     return ({
        //         data: response.data,
        //         total: response.data.length
        //     });
        // }
        // if (resource === 'cookingClass'){
        //     const response = await AxiosInstanceV2.get('/videos?type=1');
        //     return ({
        //         data: response.data,
        //         total: response.data.length
        //     });
        // }
        const response = await AxiosInstanceV2.get(`/${resource}`);
        return ({
            data: response.data,
            total: response.data.length
        });
    },

    getOne: (resource, params) => {
        // if(resource === 'infuencer'){
        //     return  AxiosInstanceV2.get(`/videos/${params.id}?type=2`).then((response) => response)
        // }
        // else if (resource === 'cookingClass'){
        //   return  AxiosInstanceV2.get(`/videos/${params.id}?type=1`).then((response) => response)
        // }
        // else {
            return  AxiosInstanceV2.get(`/${resource}/${params.id}`).then((response) => response)
        // }
    },

    getMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids }),
        };
        const url = `${apiUrl}/${resource}?${stringify(query)}`;
        return httpClient(url).then(({ json }) => ({ data: json }));
    },

    getManyReference: (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            sort: JSON.stringify([field, order]),
            range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            filter: JSON.stringify({
                ...params.filter,
                [params.target]: params.id,
            }),
        };
        const url = `${apiUrl}/${resource}?${stringify(query)}`;

        return httpClient(url).then(({ headers, json }) => ({
            data: json,
            //@ts-ignore
            total: parseInt(headers.get('content-range').split('/').pop(), 10),
        }));
    },

    update: async (resource, params) => {
        // if(resource === 'infuencer'){
        //     return  authClient().put(`/videos/${params.id}?type=2`, JSON.stringify(params.data)).then((response) => response)
        // }
        // else if (resource === 'cookingClass'){
        //     return  authClient().put(`/videos/${params.id}?type=1`, JSON.stringify(params.data)).then((response) => response)
        // }
        // else if(resource === 'categories'){
        //     // Freshly dropped pictures are File objects and must be converted to base64 strings
        //     // const newPictures = params.data.featured_image.filter(
        //     //     p => p.rawFile instanceof File
        //     // );
        //     // const formerPictures = params.data.featured_image.filter(
        //     //     p => !(p.rawFile instanceof File)
        //     // );
        //     console.log(params.data)
        //     return params.data
        // }
        // else {
            if(params.data.images1){
                const images =  params.data.images1
                const imagePaths = images.map(image => ({ url: image.rawFile ? s3Config.s3Url + "/" + image.rawFile.path : image.url, name: image.rawFile.path }));
                params.data.images = imagePaths
            }
            if(params.data.featured_image1){
                const image =  params.data.featured_image1
                params.data.featured_image = image.rawFile ? s3Config.s3Url + "/" +  image.rawFile.path : image
                console.log("param", image.rawFile.path)
            }
            return  authClient().put(`/${resource}/${params.id}`, JSON.stringify(params.data)).then((response) => response)
        // }
    },
        
    updateMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids}),
        };
        return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
            method: 'PUT',
            body: JSON.stringify(params.data),
        }).then(({ json }) => ({ data: json }));
    },

    create: (resource, params) =>{
        // const s3Url = 'https://your-s3-server.com/your-bucket/' + params.data.featured_image.rawFile.path
        if(params.data.images){
            const images =  params.data.images
            const imagePaths = images.map(image => ({ url:  s3Config.s3Url + "/" + image.rawFile.path, name: image.rawFile.path }))
            params.data.images = imagePaths
        }
        if(params.data.featured_image){
            params.data.featured_image = s3Config.s3Url + "/" + params.data.featured_image.rawFile.path
        }
        return authClient().post(`/${resource}`, JSON.stringify(params.data)).then((response) => response)
    },
    delete: (resource, params) =>{
        // if(resource === 'infuencer'){
        //     return  authClient().delete(`/videos/${params.id}?type=2`).then((response) => response)
        // }
        // else if (resource === 'cookingClass'){
        //     return authClient().delete(`/videos/${params.id}?type=1`).then((response) => response)
        // }
        // else {

            return  authClient().delete(`/${resource}/${params.id}`).then((response) => response)
        // }
    },
        

    deleteMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids}),
        };
        return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
            method: 'DELETE',
        }).then(({ json }) => ({ data: json }));
    }
};